import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-notification-form',
  templateUrl: './notification-form.component.html',
  styleUrls: ['./notification-form.component.css']
})
export class NotificationFormComponent implements OnInit {

  @Input() modalTitle;
  @Input() popup = true;
  @Input() edit = false;
  @Input() notificationID;

  @Output() closeEvent = new EventEmitter();
  @Output() result = new EventEmitter();

  /* Form */
  public formObject: any = {
    title: '',
    vehicles: '',
    timeFrom: '',
    timeTo: '',
    type: '',
    group: '',
  };
  public additionalFormObject = {
    speedLimit: '',
  };
  public errorObject = {};
  public formSubmitted: boolean = false;
  public subAddFormSubmitted: boolean = false;
  public subEditFormSubmitted: boolean = false;

  // Field options
  public fieldOptions = {
    title: [
      { value: 'overspeed', name: 'Overspeed' },
      { value: 'halt', name: 'Halt' },
      { value: 'panic', name: 'Panic' },
      { value: 'towalert', name: 'Tow alert' },
      { value: 'driverPanic', name: 'Driver panic' },
      { value: 'geofence', name: 'Geofence' },
      { value: 'route_request', name: 'Route Request' },
      { value: 'route_cancel', name: 'Route Cancel Request' },
    ],
    type: [
      { value: 'sms', name: 'SMS' },
      // {value:'call',name:'CALL'},
      { value: 'email', name: 'EMAIL' },
      { value: 'push', name: 'PUSH' },
    ],
    vehicles: [],
    group: [],
  }
  fieldOptions2 = {
    type: [
      { value: 'sms', name: 'SMS' },
      // {value:'call',name:'CALL'},
      { value: 'email', name: 'EMAIL' },
      { value: 'push', name: 'PUSH' },
    ],
  }
  public editFieldOptions = {
    group: [],
    type: [],
  }
  public showAdditionalFields: boolean = false;
  public showTitle: boolean = true;

  // Notification
  public notificationData = {};
  public selectedTitle = [];

  //vehicle
  public vehicleData = [];
  public showVehicles: boolean = false;

  //Notification Type
  public enableNotificationType: boolean = true;

  //Group
  public manageGroupData = [];
  public enableGroupDropDown: boolean = false;
  public dropDownClass = 'bg-white form-control';
  public disabledDropDownClass = 'bg-white form-control cursor-disabled';
  public groupDropDownClass = 'bg-white form-control';
  public showAddGroupForm: boolean = true;
  public showEditGroupForm: boolean = false;
  public editGroupKey = '';

  //Date and Time
  public showDate: boolean = false;
  public invalidDate: boolean = false;

  //Group Table
  public groupTable = {};

  public objKeys = Object.keys;

  constructor(private api: ApiService, public swal: SweetAlert,) { }

  ngOnInit(): void {
    this.getVehicleList();
    this.getGroupData();
  }

  ngOnChanges(changes: SimpleChange) {
    if (changes['notificationID'] && this.edit) {
      setTimeout(() => { this.getNotificationData(); }, 500);
    }
  }

  // Getting data from api
  getVehicleList() {

    this.api.transportManagerVehicleList({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleData = [...res.data];
        this.fieldOptions['vehicles'] = res.data.map(item => {
          return { "name": item.vehRegNo.toUpperCase(), value: item.vehRegNo, }
        });
      }
      else {
        this.vehicleData = [];
        this.fieldOptions['vehicles'] = [];
      }
      setTimeout(() => { this.showVehicles = true }, 300);
    })
  }
  getGroupData() {
    this.api.transportManagerManageGroupList({}).then((res: any) => {
      if (res.status == 'success') {
        this.manageGroupData = [...res.data];
        this.setFilteredGroupData(res.data);
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  // filter Group Data
  setFilteredGroupData(data) {
    if (data.length > 0) {
      let filterObj = {};
      data.filter((item) => {
        let keys = Object.keys(filterObj);
        if (keys.indexOf(item.type) == -1) filterObj[item.type] = [];
        let index = filterObj[item.type].indexOf(item.groupName);
        if (index == -1) filterObj[item.type].push(item.groupName);
      });
      setTimeout(() => {
        let objKeys = Object.keys(filterObj);
        objKeys.filter((key) => {
          filterObj[key].filter((val) => {
            let result = { name: val, type: key };
            this.fieldOptions['group'].push(result);
          })
          setTimeout(() => {
            this.enableGroupDropDown = true;
          }, 300);
        });
      }, 200);
    }
  }
  //get Notification data
  getNotificationData() {
    const obj = {
      notificationID: this.notificationID,
    };
    this.api.transportManagerNotificationSettingList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.notificationData = { ...res.data[0] };
        this.patchNotificationData(res.data[0]);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  patchNotificationData(obj) {
    this.showAdditionalFields = false;
    this.showVehicles = false;
    this.enableNotificationType = false;
    this.showTitle = false;

    this.formObject = {
      title: obj.title,
      vehicles: obj.vehicles,
      timeFrom: obj.timeFrom,
      timeTo: obj.timeTo,
      type: '',
      group: ''
    };
      if (obj.sms && obj.sms.length > 0) { this.groupTable['sms'] = obj.sms; this.patchNotificationType('sms'); }
      if (obj.push && obj.push.length > 0) { this.groupTable['push'] = obj.push; this.patchNotificationType('push'); }
      if (obj.email && obj.email.length > 0) { this.groupTable['email'] = obj.email; this.patchNotificationType('email'); }

    this.patchVehicleList(this.formObject.vehicles);

    this.showAddGroupForm = this.checkAddGroupForm();
    this.enableNotificationType = true;

    this.selectedTitle = [];
    this.selectedTitle.push(this.patchNotificationFor(this.formObject.title));

    if (this.formObject.title == 'overspeed') {
      this.formObject['speedLimit'] = obj.speedLimit;
      setTimeout(() => { this.showAdditionalFields = true }, 300);
    }

    setTimeout(() => {
      this.showVehicles = true;
      this.showTitle = true;
    }, 1000);
  }

  patchNotificationFor(value) {
    let result = {}
    this.fieldOptions.title.filter((e) => { if (e.value == value) result = e; });
    return result;
  }
  patchVehicleList(value) {
    this.fieldOptions.vehicles = this.fieldOptions.vehicles.map((veh) => {
      let obj = { ...veh };
      let index = value?.indexOf(obj.value);
      if (index != -1) { obj['checked'] = true; }
      return obj;
    });
    setTimeout(() => {  });
  }
  patchNotificationType(value) {
    this.fieldOptions['type'] = this.fieldOptions['type'].map((element) => {
      let obj = { ...element };
      if (value == element.value) obj['disabled'] = true;
      return obj;
    });
  }


  //search and select result
  searchSelectResult(e, field) {
    if (field == 'type') {
      this.formObject[field] = e.value;
      this.enableGroupDropDown = false;

      this.fieldOptions['group'] = this.fieldOptions['group'].map((element) => {
        let obj = { disabled: true, ...element };
        if (e.value == 'sms' || e.value == 'call' || e.value == 'push') {
          if (obj.type == 'mobile') delete obj.disabled;
        }
        else if (e.value == 'email') {
          if (obj.type == 'email') delete obj.disabled;
        }
        return obj;
      });
      setTimeout(() => { this.enableGroupDropDown = true; }, 200);

    }
    else if (field == 'group') {
      if (e.length > 0) {
        e.filter((item) => {
          let index = this.formObject[field].indexOf(item.name);
          if (index == -1) {
            if (!Array.isArray(this.formObject[field])) this.formObject[field] = [];
            this.formObject[field].unshift(item.name);
          }
        });
      } else this.formObject[field] = '';
    }
    else if (field == 'vehicles') {
      if (e.length > 0) {
        e.filter((item) => {
          let index = this.formObject[field].indexOf(item.value);
          if (index == -1) {
            if (!Array.isArray(this.formObject[field])) this.formObject[field] = [];
            this.formObject[field].push(item.value);
          }
        });
      } else this.formObject[field] = '';
    }
    else if (field == 'title') {
      this.formObject[field] = e.value;
      this.showAdditionalFields = false;
      for (const key in this.additionalFormObject) {
        delete this.formObject[key];
      }
      if (e.value == 'overspeed') {
        this.formObject['speedLimit'] = '';
        this.showAdditionalFields = true;
      }

      if (['route_cancel', 'route_request'].includes(e.value)) {
        delete this.formObject.vehicles;

        let output2 = [];
        this.manageGroupData.forEach((item: any) => {
          if (item.type == 'email') {
            output2.push({
              name: item.groupName, type: item.type
            })
          }
        });

        let types = [];
        this.fieldOptions.type.forEach((item: any) => {
          if (item.value == 'email') {
            types.push({
              value: item.value, name: item.name
            })
          }
        });
        this.fieldOptions.group = output2;
        this.fieldOptions.type = types;
      } else {
        let output2 = [];
        this.manageGroupData.forEach((item: any) => {
          output2.push({
            name: item.groupName, type: item.type
          })
        });
        this.fieldOptions.group = output2;
        this.fieldOptions.type = this.fieldOptions2.type;

      }
      // this.formObject = this.formObject.map((element)=>{ if(element) return element;}); 
    }
    if (this.formSubmitted) this.validation('mainForm', Object.keys(this.formObject));
    if (this.subAddFormSubmitted) this.validation('subAddForm', ['type', 'group']);
    if (this.subEditFormSubmitted) this.validation('subEditForm', ['group']);
  }

  validation(formType, objectKeys) {
    this.errorObject = {};
    let isValid = true;
    for (let i = 0; i < objectKeys.length; i++) {
      let key = objectKeys[i];
      this.errorObject[key] = '';
      if (formType == 'mainForm') {
        if (key != 'type' && key != 'group') {
          if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
            this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
            isValid = false;
          }
          else {
            if (key == 'speedLimit' && this.formObject[key] < 0) {
              this.errorObject[key] = "Speed Limit is Invalid.";
              isValid = false;
            }
          }
        }
        else {
          if (Object.keys(this.groupTable).length <= 0) {
            if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
              this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
              isValid = false;
            }
            else if ((this.formObject.type != '') && (this.formObject.group != '')) {
              this.errorObject['subAddForm'] = "Add notification type";
              isValid = false;
            }
          } else {
            if (this.showEditGroupForm) {
              if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
                this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
                isValid = false;
              }
            }
          }
        }
      }
      else if (formType == 'subAddForm') {
        if (key == 'type' || key == 'group') {
          if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
            this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
            isValid = false;
          }
        }
      }
      else if (formType == 'subEditForm') {
        if (key == 'group') {
          if (this.formObject[key] == '' || this.formObject[key] == undefined || this.formObject[key] == null || this.formObject[key].length <= 0) {
            this.errorObject[key] = key.split(/(?=[A-Z])/).join(" ").toLowerCase() + ' is required.';
            isValid = false;
          }
        }
      }
    }
    return isValid;
  }

  submitGroup() {
    if (this.formSubmitted) this.validation('mainForm', this.objKeys(this.formObject));
    let isValid = this.validation('subAddForm', ['type', 'group']);
    this.subAddFormSubmitted = true;
    if (isValid) {

      let type = this.formObject['type'];
      this.groupTable[type] = this.formObject['group'];
      this.enableNotificationType = false;
      this.enableGroupDropDown = false;

      this.fieldOptions['type'] = this.fieldOptions['type'].map((element) => {
        let obj = { ...element };
        if (type == element.value) obj['disabled'] = true;
        return obj;
      });

      let showForm = this.checkAddGroupForm();
      this.clearGroupChecked();
      setTimeout(() => {
        this.formObject['type'] = '';
        this.formObject['group'] = '';
        this.showAddGroupForm = showForm;
        this.enableNotificationType = true;
        this.enableGroupDropDown = true;
        this.subAddFormSubmitted = false;
      }, 200);
    }
  }

  clearGroupChecked() {
    this.fieldOptions['group'] = this.fieldOptions['group'].map((element) => {
      if (element.checked) delete element.checked;
      let obj = { ...element };
      return obj;
    });
    if (this.editGroupKey != '') {
      this.editFieldOptions['group'] = this.editFieldOptions['group'].map((element) => {
        if (element.checked) delete element.checked;
        let obj = { ...element };
        return obj;
      });
    }
  }

  checkAddGroupForm() {
    let result: boolean = false;
    this.fieldOptions['type'].filter((e) => {
      if (!(Object.keys(e).includes('disabled'))) result = true;
    })
    return result
  }

  editGroupType(key) {
    this.showAddGroupForm = false;
    this.editGroupKey = key;
    this.clearGroupChecked();
    setTimeout(() => {

      this.editFieldOptions.group = this.fieldOptions.group.map((group) => {
        let obj = { ...group };
        if (obj['disabled']) delete obj['disabled'];
        if (this.groupTable[key].includes(obj.name)) obj['checked'] = true;
        return { ...obj };
      })
      this.showEditGroupForm = true;
    }, 100);
  }

  updateGroupType(key) {
    if (this.formSubmitted) this.validation('mainForm', this.objKeys(this.formObject));
    let isValid = this.validation('subEditForm', ['group']);
    this.subEditFormSubmitted = true;
    if (isValid) {
      this.groupTable[key] = this.formObject['group'];
      setTimeout(() => {
        this.cancelEditGroupType(key);
      }, 200);
      this.subEditFormSubmitted = false;
    }
  }

  cancelEditGroupType(key) {
    this.editGroupKey = '';
    this.formObject['group'] = '';
    this.clearGroupChecked();
    this.showAddGroupForm = this.checkAddGroupForm();
    this.showEditGroupForm = false;
    this.subEditFormSubmitted = false;
  }

  deleteGroupType(key) {
    this.enableNotificationType = false;
    this.fieldOptions.type = this.fieldOptions.type.map((element) => {
      if (element['disabled'] && element.value == key) delete element['disabled'];
      let obj = { ...element };
      return obj
    })
    let obj = { ...this.groupTable };
    delete obj[key];
    this.groupTable = { ...obj };
    setTimeout(() => {
      this.enableNotificationType = true;
      this.showAddGroupForm = true;
    }, 200);
  }

  onSubmit(type) {
    let objectKeys = Object.keys(this.formObject);
    let isValid = this.validation('mainForm', objectKeys);
    this.formSubmitted = true;
    if (isValid) {
      let obj = {
        ...this.formObject,
      };
      delete obj['type'];
      delete obj['group'];
      obj['group'] = this.groupTable;

      let apiMethod = "";
      if (type == 'update') {
        apiMethod = "transportManagerNotificationSettingUpdate";
        obj['notificationID'] = this.notificationID;
      }
      else apiMethod = "transportManagerNotificationSettingCreate";

      this.api[apiMethod](obj).then((res: any) => {
        if (res.status == 'success') {
          this.closeEvent.emit(true);
          this.result.emit(true);
          this.swal.swalFunction(res.status, res.status, res.message, 20000);
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 20000);
        }
      });
    }
  }
}
